function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgPc01 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.59364,30.86249c.18156,8.38475,4.78351,13.96283,10.86924,17.91108",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.09061,40.35774c-3.94108-3.1213-5.12754-6.76286-6.27421-9.88208",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.83208,48.74393c-.19488.21323-.39144.41837-.596.62523a3.20946,3.20946,0,0,1-4.36375.11684c-2.87629-2.49025-7.74268-7.61457-9.21409-14.80882a3.23047,3.23047,0,0,1,2.2171-3.77733c.23821-.06677.4925-.137.75972-.2056a19.9721,19.9721,0,0,1,9.10019-.2404c.36543.07889.73742.169,1.10472.27686a7.72193,7.72193,0,0,1,5.36268,9.1731q-.07681.32505-.16318.66473A19.50646,19.50646,0,0,1,77.83208,48.74393Z",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.03184,
    cy: 38.33137,
    r: 2.55639,
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.54881,30.47631a2.46484,2.46484,0,0,1-.38774,1.23457,2.55817,2.55817,0,0,1-4.70147-1.04349",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.07992,42.58175a2.55707,2.55707,0,0,0-2.58071,4.41155,1.84911,1.84911,0,0,0,.32048.16807",
    style: {
      fill: "none",
      stroke: "#276ef1",
      strokeMiterlimit: 10,
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28568,88.39755c-.75048-1.46026-1.53006-2.86233-2.33291-4.19459A56.99557,56.99557,0,0,0,32.45939,57.76132,65.53291,65.53291,0,0,0,5.785,56.03346",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.95279,84.203l-8.08085-.72143c-.06981-.00579-.14545-.01161-.21526-.01161a2.38938,2.38938,0,0,0-2.02459,1.13447,2.37653,2.37653,0,0,1-2.69941,1.04136L28.31715,78.0187a2.3738,2.3738,0,0,1-1.658-2.70526l1.26244-6.8475a2.36885,2.36885,0,0,0-.65741-2.106l-1.10538-1.11118a2.37278,2.37278,0,0,1,.38981-3.671l5.91081-3.81644A56.99566,56.99566,0,0,1,66.95279,84.203Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.535,63.23362l5.73233,3.65894a1.84728,1.84728,0,0,1,.82748,1.86533L22.207,74.004a1.84726,1.84726,0,0,1-3.18052.9428L11.24959,66.4979a1.84727,1.84727,0,0,1,1.07521-3.07635l2.93232-.45614A1.84729,1.84729,0,0,1,16.535,63.23362Z",
    style: {
      fill: "none",
      stroke: "#6e6bb3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.24 57.385 92.043 53.528 90.658 56.399 74.586 60.156 77.24 57.385",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6582,56.399s1.188,3.843,2.08552,2.06831-.70027-4.93912-.70027-4.93912",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.58644,60.15648a3.00959,3.00959,0,0,0,1.18863,2.92511L92.09284,59.0313",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.017 34.071 49.496 18.982 47.441 21.418 50.57 37.624 52.017 34.071",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.44051,21.41844s-3.99318.484-2.73941-1.05966,4.79478-1.37672,4.79478-1.37672",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.45191,21.18316,47.41479,37.733a3.0096,3.0096,0,0,0,3.15551-.10882",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.92207,16.07922a8.61633,8.61633,0,0,0-6.18872-.62125",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.73346,13.358a8.81069,8.81069,0,0,0-6.12207,1.18412",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.562,52.6602a11.46651,11.46651,0,0,1-1.67775,8.19268",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.54665,49.17876a9.84336,9.84336,0,0,1,1.042,6.72957",
    style: {
      fill: "none",
      stroke: "#0f62fe",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.10433,71.14908s.18457-.83191.64429-2.23352",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.203,65.09939A46.419,46.419,0,0,1,59.58383,47.31607",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px",
      strokeDasharray: "4.085512638092041,4.085512638092041"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.21371,46.07815q.93018-.67126,1.92456-1.30871",
    style: {
      fill: "none",
      stroke: "#ff7d49",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1635480932168545px"
    }
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgPc01);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PC01.7de40a6d296f846f8f79e6193b1cf00f.svg";